import 'select2';
import 'select2/dist/css/select2.css';

import './select2-custom.css';

import $ from 'jquery';

type SelectionRenderer = () => JQuery<HTMLElement>;

interface SelectionPrototype {
    render: SelectionRenderer;
    update?: (data: unknown) => void;
}

type SelectionClass = {
    prototype: SelectionPrototype;
};

interface Select2Utils {
    Decorate<T extends SelectionClass>(decorated: T, decorator: SelectionClass): SelectionClass;
}

type Select2AMDWithDefine = Select2.Select2Plugin['amd'] & {
    define(
        name: string,
        dependencies: readonly string[],
        factory: (
            Utils: Select2Utils,
            BaseSelection: SelectionClass,
            Placeholder: SelectionClass,
            EventRelay: SelectionClass,
            SingleSelection: SelectionClass
        ) => SelectionClass
    ): void;
};

const select2Plugin = $.fn.select2 as Select2.Select2Plugin & { amd: Select2AMDWithDefine };

// SingleSelection adapter that uses a Font Awesome icon as dropdown arrow.
select2Plugin.amd.define(
    'FontAwesomeSingleSelection',
    [
        'select2/utils',
        'select2/selection/base',
        'select2/selection/placeholder',
        'select2/selection/eventRelay',
        'select2/selection/single',
    ],
    (
        Utils: Select2Utils,
        BaseSelection: SelectionClass,
        Placeholder: SelectionClass,
        EventRelay: SelectionClass,
        SingleSelection: SelectionClass
    ) => {
        // Decorates SingleSelection with Placeholder.
        let adapter = Utils.Decorate(SingleSelection, Placeholder);
        // Decorates adapter with EventRelay - ensures events will continue to fire
        // e.g. selected, changed.
        adapter = Utils.Decorate(adapter, EventRelay);

        adapter.prototype.render = function render(this: SelectionPrototype): JQuery<HTMLElement> {
            const $selection = BaseSelection.prototype.render.call(this);

            $selection.addClass('select2-selection--single');

            $selection.html(
                '<span class="select2-selection__rendered"></span>' +
                    '<span class="select2-selection__arrow" role="presentation">' +
                    '<i class="fa fa-angle-down"></i>' +
                    '</span>'
            );

            return $selection;
        };

        adapter.prototype.update = function update(this: SelectionPrototype, data: unknown): void {
            SingleSelection.prototype.update?.call(this, data);
        };

        return adapter;
    }
);

const FontAwesomeSingleSelection = select2Plugin.amd.require(
    'FontAwesomeSingleSelection'
) as SelectionClass;

export default FontAwesomeSingleSelection;
